import React, {  useState } from 'react'
import Title from '../layouts/Title';
import Education from './Education';
import Skills from './Skills';
import ResumeCard from './ResumeCard';
import ResumeResume from './ResumeResume';

const Resume = () => {
   const [educationData, setEducationData] = useState(true);
   const [skillData, setSkillData] = useState(false);
   const [resumeData, setResumeData] = useState(false);


  return (
    <section id="resume" className="w-full py-20 border-b-[1px] border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title title="" des="My Education & Skills" />
      </div>
      <div style={{width:'50%',margin:'auto'}}>
        <ul className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4" style={{width:'100%', margin:'auto',justifyContent:'center',display:'flex',gap:'10%',borderRadius:'15px',textAlign:'center'}}>
          <li
            onClick={() =>
              setEducationData(true) &
              setSkillData(false) &
              setResumeData(false)
             
            }
            className={`${
              educationData
                ? "border-designColor rounded-lg"
                : "border-transparent"
            } resumeLi`}
          >
            Education
          </li>
          <li
            onClick={() =>
              setEducationData(false) &
              setSkillData(true) &
              setResumeData(false)
             
            }
            className={`${
              skillData ? "border-designColor rounded-lg" : "border-transparent"
            } resumeLi`}
          >
            Professional Skills
          </li>
          {/* ==============================================================================resume================================================= */}
          <li
            onClick={() =>
              setEducationData(false) &
              setSkillData(false) &
              setResumeData(true) 
             
            }
            className={`${
              resumeData ? "border-designColor rounded-lg" : "border-transparent"
            } resumeLi`}
          >
            Resume
          </li>
          
        
       
        </ul>
      </div>
      {educationData && <Education />}
      {skillData && <Skills />}
      {resumeData && <ResumeResume title="Soubhagya Resume"/>}
    </section>
  );
}

export default Resume